import React, { useEffect } from 'react';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';

// Seq Logging
import { setupAxiosLogger } from './helpers/axios-logger-interceptor';
import { loggerService } from './helpers/logger';
import ErrorBoundary from './Components/Common/ErrorBoundary';

// Activating fake backend
fakeBackend();

// Setup Seq logging cho axios
setupAxiosLogger();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  useEffect(() => {
    // Log application start
    loggerService.info('Application Started', {
      version: '4.1.0',
      environment: process.env.NODE_ENV,
      timestamp: new Date().toISOString(),
    });

    // Log unhandled promise rejections
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      loggerService.error('Unhandled Promise Rejection', new Error(event.reason), {
        reason: event.reason,
        eventType: 'UnhandledRejection',
      });
    };

    // Log global errors
    const handleError = (event: ErrorEvent) => {
      loggerService.error('Global Error', event.error, {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        eventType: 'GlobalError',
      });
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleError);

    // Cleanup
    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleError);
      
      // Flush logs khi app unmount
      loggerService.flush().then(() => {
        loggerService.info('Application Stopped');
      });
    };
  }, []);

  return (
    <ErrorBoundary>
      <React.Fragment>
        <ToastContainer style={{ zIndex: 10000 }} />
        <Route />
      </React.Fragment>
    </ErrorBoundary>
  );
}

export default App;
